import PropTypes from 'prop-types'
import MDEditor from '@uiw/react-md-editor'

export default function Section({
  section: { title, content, attachments },
  renderAttachment,
  toggleModal,
  setAttachment,
}) {
  return (
    <div className="settings--view" data-testid="data-testsection">
      <h2>{title}</h2>
      <MDEditor.Markdown source={content} />
      <div className="support-attachments">
        {attachments.map(attachment =>
          renderAttachment(attachment, toggleModal, setAttachment),
        )}
      </div>
    </div>
  )
}

Section.propTypes = {
  section: PropTypes.object.isRequired,
  renderAttachment: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  setAttachment: PropTypes.func.isRequired,
}
